// Header, phone menu, profile menu, footer and the language switcher.
// See messages/README.md for how to add strings.
export const nav = {
  en: {
    "nav.home": "Home",
    "nav.create": "Create",
    "nav.voices": "Voices",
    "nav.train": "Train a voice",
    "nav.library": "Library",
    "nav.tab.profile": "Profile",
    "nav.pricing": "Pricing",
    "nav.affiliate": "Affiliate Program",
    "nav.api": "API",
    "nav.login": "Log in",
    "nav.signup": "Sign up",
    "nav.signupFree": "Sign up free",
    "nav.getPlan": "Get a plan",
    "nav.discordAria": "Join the Jammable Discord",
    "nav.discordJoin": "Join our Discord",
    "nav.openMenu": "Open menu",
    "nav.closeMenu": "Close menu",

    // Profile menu. Greetings are picked at random by time of day:
    // 0 morning, 1 afternoon, 2 evening, 3 late night; five of each.
    "nav.greet.0.0": "Hey, early riser",
    "nav.greet.0.1": "Morning",
    "nav.greet.0.2": "Sup",
    "nav.greet.0.3": "Hey there",
    "nav.greet.0.4": "What's up",
    "nav.greet.1.0": "Yo",
    "nav.greet.1.1": "Hey",
    "nav.greet.1.2": "Hi there",
    "nav.greet.1.3": "What's good",
    "nav.greet.1.4": "Howdy",
    "nav.greet.2.0": "Evening",
    "nav.greet.2.1": "Hey you",
    "nav.greet.2.2": "What's happening",
    "nav.greet.2.3": "Hi",
    "nav.greet.2.4": "Hiya",
    "nav.greet.3.0": "Still up?",
    "nav.greet.3.1": "Night owl, huh?",
    "nav.greet.3.2": "Yo, night person",
    "nav.greet.3.3": "Can't sleep?",
    "nav.greet.3.4": "Late night vibes",
    "nav.profile.view": "View profile",
    "nav.profile.credit": "Credit",
    "nav.profile.credits": "Credits",
    "nav.profile.voicePass": "Voice Pass",
    "nav.profile.voices": "Voices",
    "nav.profile.shop": "Item Shop",
    "nav.profile.feedback": "Give Feedback",
    "nav.profile.settings": "Settings",
    "nav.profile.apiDashboard": "API Dashboard",
    "nav.profile.signOut": "Sign out",
    "nav.profile.signedOut": "Signed out!",
    "nav.profile.avatarAlt": "user avatar",

    // Footer
    "nav.footer.tagline":
      "AI covers with 100,000+ voices. Make one in seconds.",
    "nav.footer.colCreate": "Create",
    "nav.footer.colAccount": "Account",
    "nav.footer.colLegal": "Legal",
    "nav.footer.aiCover": "AI Cover Generator",
    "nav.footer.voiceChanger": "AI Voice Changer",
    "nav.footer.voiceLibrary": "AI Voice Library",
    "nav.footer.train": "Train a Voice",
    "nav.footer.weights": "Weights.gg Alternative",
    "nav.footer.settings": "Settings",
    "nav.footer.earn": "Earn with Jammable",
    "nav.footer.mcp": "MCP Server for AI Agents",
    "nav.footer.forgot": "Forgot password",
    "nav.footer.terms": "Terms of Use",
    "nav.footer.privacy": "Privacy Policy",
    "nav.footer.dmca": "DMCA Policy",
    "nav.footer.refunds": "Refund Policy",
    // "Uses <link>Pitchmeld technology</link> for voice processing"
    "nav.footer.pitchmeldBefore": "Uses",
    "nav.footer.pitchmeldLink": "Pitchmeld technology",
    "nav.footer.pitchmeldAfter": "for voice processing",

    "nav.language": "Language",
  },
  es: {
    "nav.home": "Inicio",
    "nav.create": "Crear",
    "nav.voices": "Voces",
    "nav.train": "Entrenar una voz",
    "nav.library": "Biblioteca",
    "nav.tab.profile": "Perfil",
    "nav.pricing": "Precios",
    "nav.affiliate": "Programa de afiliados",
    "nav.api": "API",
    "nav.login": "Iniciar sesión",
    "nav.signup": "Registrarse",
    "nav.signupFree": "Regístrate gratis",
    "nav.getPlan": "Elige un plan",
    "nav.discordAria": "Únete al Discord de Jammable",
    "nav.discordJoin": "Únete a nuestro Discord",
    "nav.openMenu": "Abrir menú",
    "nav.closeMenu": "Cerrar menú",

    "nav.greet.0.0": "¡Qué madrugador!",
    "nav.greet.0.1": "Buenos días",
    "nav.greet.0.2": "¿Todo bien?",
    "nav.greet.0.3": "Hola",
    "nav.greet.0.4": "¿Qué tal?",
    "nav.greet.1.0": "Ey",
    "nav.greet.1.1": "Hola",
    "nav.greet.1.2": "¿Qué hay?",
    "nav.greet.1.3": "¿Cómo va todo?",
    "nav.greet.1.4": "Buenas tardes",
    "nav.greet.2.0": "Buenas noches",
    "nav.greet.2.1": "Hola, tú",
    "nav.greet.2.2": "¿Qué cuentas?",
    "nav.greet.2.3": "Hola",
    "nav.greet.2.4": "¡Buenas!",
    "nav.greet.3.0": "¿Sigues despierto?",
    "nav.greet.3.1": "Noctámbulo, ¿eh?",
    "nav.greet.3.2": "Ey, búho nocturno",
    "nav.greet.3.3": "¿No puedes dormir?",
    "nav.greet.3.4": "Vibras de madrugada",
    "nav.profile.view": "Ver perfil",
    "nav.profile.credit": "crédito",
    "nav.profile.credits": "créditos",
    "nav.profile.voicePass": "pase de voz",
    "nav.profile.voices": "voces",
    "nav.profile.shop": "Tienda",
    "nav.profile.feedback": "Enviar comentarios",
    "nav.profile.settings": "Configuración",
    "nav.profile.apiDashboard": "Panel de la API",
    "nav.profile.signOut": "Cerrar sesión",
    "nav.profile.signedOut": "¡Sesión cerrada!",
    "nav.profile.avatarAlt": "foto de perfil",

    "nav.footer.tagline":
      "Covers con IA y más de 100 mil voces. Haz el tuyo en segundos.",
    "nav.footer.colCreate": "Crear",
    "nav.footer.colAccount": "Cuenta",
    "nav.footer.colLegal": "Legal",
    "nav.footer.aiCover": "Generador de covers con IA",
    "nav.footer.voiceChanger": "Cambiador de voz con IA",
    "nav.footer.voiceLibrary": "Biblioteca de voces IA",
    "nav.footer.train": "Entrenar una voz",
    "nav.footer.weights": "Alternativa a Weights.gg",
    "nav.footer.settings": "Configuración",
    "nav.footer.earn": "Gana con Jammable",
    "nav.footer.mcp": "Servidor MCP para agentes de IA",
    "nav.footer.forgot": "Olvidé mi contraseña",
    "nav.footer.terms": "Términos de uso",
    "nav.footer.privacy": "Política de privacidad",
    "nav.footer.dmca": "Política DMCA",
    "nav.footer.refunds": "Política de reembolsos",
    "nav.footer.pitchmeldBefore": "Usa la",
    "nav.footer.pitchmeldLink": "tecnología Pitchmeld",
    "nav.footer.pitchmeldAfter": "para procesar la voz",

    "nav.language": "Idioma",
  },
  pt: {
    "nav.home": "Início",
    "nav.create": "Criar",
    "nav.voices": "Vozes",
    "nav.train": "Treinar uma voz",
    "nav.library": "Biblioteca",
    "nav.tab.profile": "Perfil",
    "nav.pricing": "Preços",
    "nav.affiliate": "Programa de afiliados",
    "nav.api": "API",
    "nav.login": "Entrar",
    "nav.signup": "Cadastrar",
    "nav.signupFree": "Cadastre-se grátis",
    "nav.getPlan": "Assine um plano",
    "nav.discordAria": "Entre no Discord do Jammable",
    "nav.discordJoin": "Entre no nosso Discord",
    "nav.openMenu": "Abrir menu",
    "nav.closeMenu": "Fechar menu",

    "nav.greet.0.0": "Acordou cedo, hein",
    "nav.greet.0.1": "Bom dia",
    "nav.greet.0.2": "E aí",
    "nav.greet.0.3": "Olá",
    "nav.greet.0.4": "Beleza?",
    "nav.greet.1.0": "Opa",
    "nav.greet.1.1": "Oi",
    "nav.greet.1.2": "Olá",
    "nav.greet.1.3": "Tudo certo?",
    "nav.greet.1.4": "Boa tarde",
    "nav.greet.2.0": "Boa noite",
    "nav.greet.2.1": "Oi, você",
    "nav.greet.2.2": "Quais as novidades?",
    "nav.greet.2.3": "Oi",
    "nav.greet.2.4": "Fala aí",
    "nav.greet.3.0": "Ainda acordado?",
    "nav.greet.3.1": "Coruja, hein?",
    "nav.greet.3.2": "E aí, notívago",
    "nav.greet.3.3": "Sem sono?",
    "nav.greet.3.4": "Clima de madrugada",
    "nav.profile.view": "Ver perfil",
    "nav.profile.credit": "crédito",
    "nav.profile.credits": "créditos",
    "nav.profile.voicePass": "passe de voz",
    "nav.profile.voices": "vozes",
    "nav.profile.shop": "Loja",
    "nav.profile.feedback": "Enviar feedback",
    "nav.profile.settings": "Configurações",
    "nav.profile.apiDashboard": "Painel da API",
    "nav.profile.signOut": "Sair",
    "nav.profile.signedOut": "Você saiu da conta!",
    "nav.profile.avatarAlt": "foto de perfil",

    "nav.footer.tagline":
      "Covers com IA e mais de 100 mil vozes. Faça o seu em segundos.",
    "nav.footer.colCreate": "Criar",
    "nav.footer.colAccount": "Conta",
    "nav.footer.colLegal": "Legal",
    "nav.footer.aiCover": "Gerador de covers com IA",
    "nav.footer.voiceChanger": "Modificador de voz com IA",
    "nav.footer.voiceLibrary": "Biblioteca de vozes de IA",
    "nav.footer.train": "Treinar uma voz",
    "nav.footer.weights": "Alternativa ao Weights.gg",
    "nav.footer.settings": "Configurações",
    "nav.footer.earn": "Ganhe com o Jammable",
    "nav.footer.mcp": "Servidor MCP para agentes de IA",
    "nav.footer.forgot": "Esqueci minha senha",
    "nav.footer.terms": "Termos de uso",
    "nav.footer.privacy": "Política de privacidade",
    "nav.footer.dmca": "Política DMCA",
    "nav.footer.refunds": "Política de reembolso",
    "nav.footer.pitchmeldBefore": "Usa a",
    "nav.footer.pitchmeldLink": "tecnologia Pitchmeld",
    "nav.footer.pitchmeldAfter": "para processamento de voz",

    "nav.language": "Idioma",
  },
};
